import { html, css, LitElement } from 'lit-element';

// import { emitEvent } from './utility.js' // Not used
import { a11yStyles, disclosureButton, uniqueId } from './a11y.js';
import { t, Localized } from './i18n.js';

import './admin_domains.js';
import './admin_surveys.js';
import './admin_invitation_template.js';
import './admin_ai_config.js';

// Manage Domains
export class IntrivityAdminConfig extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Matches the CLIENTS / TRAINER GROUPS panel headers. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }
    
    static get properties() {
        return {
            user_profile: { type: Object },
            expanded: { type: Boolean }   
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('configuration');
        this.expanded = false;
    }

    connectedCallback() {
        super.connectedCallback(); 
    }
    
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    render() {
        return html`
            
            <h2 class="section-header">
                ${t('adminConfig.title')}
                ${disclosureButton(this.expanded, t('adminConfig.title'), this._panelId, () => { this.expanded = !this.expanded; })}
            </h2>            
            
            ${this.expanded ? html`
                <intrivity-admin-domains .user_profile=${this.user_profile}></intrivity-admin-domains>
                <intrivity-admin-surveys></intrivity-admin-surveys>
                <intrivity-admin-invitation-template .user_profile=${this.user_profile}></intrivity-admin-invitation-template>
                <intrivity-admin-ai-config .user_profile=${this.user_profile}></intrivity-admin-ai-config>
            `: html`

            `}
            
        `
    } 
 
}
if (!customElements.get('intrivity-admin-config')) customElements.define('intrivity-admin-config', IntrivityAdminConfig);
